import { render, staticRenderFns } from "./MockupWidgetPreview.vue?vue&type=template&id=1b638a6e&scoped=true&"
import script from "./MockupWidgetPreview.vue?vue&type=script&lang=ts&"
export * from "./MockupWidgetPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MockupWidgetPreview.vue?vue&type=style&index=0&id=1b638a6e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b638a6e",
  null
  
)

export default component.exports